import React from 'react';
import { AvidReaderJanFeb2025 } from '../views';

const DesktopAppPage = () => {
  return <AvidReaderJanFeb2025/>;
};
export default DesktopAppPage;
